import type { RunState } from "../types/index.js";
import { draw } from "./draw.js";

/** 施策によるドローだけを制限する。公開・開始時の補充は通常のdrawを使う。 */
export function actionDraw(run: RunState, count: number) {
  const limit = run.activeCase?.actionDrawLimit;
  const remaining = limit == null ? undefined : run.actionDrawRemaining ?? limit;
  const result = draw(run, remaining == null ? count : Math.min(count, remaining));
  return {
    ...result,
    run: {
      ...run,
      deck: result.deck, discard: result.discard, rngState: result.rngState,
      actionDrawRemaining: remaining == null ? undefined : Math.max(0, remaining - result.drawn.length),
    },
  };
}
